var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVeggies = function SvgVeggies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Veggies_svg__clip0_1811_217980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.582 10.452c-.087-.34-.306-.637-.622-.878-.448-.33-.514-.966-.131-1.35.054-.066.12-.121.174-.187 1.082-1.252 1.322-2.766.536-3.381-.787-.615-2.294-.11-3.376 1.142-1.038 1.196-1.3 2.645-.623 3.304-1.65.362-2.818 1.36-2.807 2.37-.852-.252-1.65-.175-2.12.286-.84.823-.36 2.558 1.071 3.864s3.267 1.701 4.108.878c.491-.483.524-1.284.185-2.118-.218-.538.11-1.11.689-1.23h.01c1.88-.373 3.18-1.58 2.906-2.7z",
    fill: "url(#Veggies_svg__paint0_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 13.812a1.116 1.116 0 00-.46-.768c.94-.494 1.465-1.46 1.202-2.382-.175-.637-.688-1.109-1.332-1.329.786-.636 1.212-1.591 1.026-2.546a2.5 2.5 0 00-.546-1.12c.525-.33.962-.867 1.19-1.537.492-1.427-.108-2.93-1.343-3.359-1.234-.428-2.632.374-3.124 1.8-.12.341-.175.692-.175 1.033a1.714 1.714 0 01-.841 1.514c-1.06.615-1.671 1.724-1.453 2.843.131.67.546 1.23 1.114 1.614.547.362.852.999.787 1.647-.022.219-.011.45.054.68.088.33.274.615.514.845.36.34.557.79.579 1.274v.065c.065.66.754 1.131 1.53 1.065.775-.077 1.354-.67 1.277-1.339z",
    fill: "url(#Veggies_svg__paint1_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.795 8.85a.54.54 0 01.076-.703c1.115-1.02 1.475-2.492.798-3.512-.404-.604-1.103-.922-1.89-.955a.535.535 0 01-.503-.516c-.054-1.625-.873-2.942-2.064-3.14-1.278-.208-2.556.944-3.059 2.657a.513.513 0 01-.546.373c-.306-.022-.601.011-.896.099-1.518.494-2.229 2.502-1.595 4.49.098.307.219.592.372.856.109.197.065.45-.088.614a2.543 2.543 0 00-.524 2.624 2.5 2.5 0 003.638 1.262 2.49 2.49 0 001.365 1.921 2.481 2.481 0 003.114-.79 2.47 2.47 0 00.415-1.866.526.526 0 01.327-.582c.721-.264 1.246-.758 1.377-1.416.12-.483-.011-.977-.317-1.416z",
    fill: "url(#Veggies_svg__paint2_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.865 18.138c-.71 2.82-1.31 4.292-3.386 3.754-2.076-.527-1.901-2.108-1.18-4.929.27-1.079 1.08-2.877 1.978-4.689-.75-.94-1.227-1.762-1.095-1.875.122-.104.726.423 1.42 1.226.15-.299.303-.595.454-.887a17.548 17.548 0 01-.048-.24c-.251-1.306-.306-2.382-.12-2.426.157-.028.431.706.664 1.717.48-.91.924-1.726 1.258-2.332.164-.296.612-.187.612.154.005.628.008 1.445 0 2.354.537-.88 1.03-1.482 1.16-1.4.163.089-.23 1.098-.886 2.251-.098.175-.196.344-.293.503-.005.3-.013.603-.02.908 1.066-.661 1.986-1.066 2.092-.917.098.154-.721.856-1.846 1.559a18.14 18.14 0 01-.272.166c-.074 2.038-.219 4.022-.492 5.103z",
    fill: "url(#Veggies_svg__paint3_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.072 17.424c.686 3.622 3.124 4.674 7.83 4.568 3.124 0 2.195-2.137 2.195-5.086 0-2.949-1.942-5.407-4.725-5.354-3.138.158-5.852 2.98-5.3 5.872z",
    fill: "url(#Veggies_svg__paint4_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.867c.02-2.987-2.065-5.386-4.847-6.183-2.84-.816-5.197 1.173-5.192 4.07.005 2.91 2.413 5.793 5.293 6.18 2.785.376 4.728-1.162 4.747-4.067z",
    fill: "url(#Veggies_svg__paint5_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.752 17.792c.018-2.839-1.962-5.118-4.606-5.876-2.7-.772-4.94 1.118-4.935 3.87.005 2.767 2.29 5.505 5.028 5.873 2.646.357 4.494-1.106 4.513-3.867z",
    fill: "url(#Veggies_svg__paint6_linear_1811_217980)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.928 16.131l.775-3.034c.059-.227-.111-.493-.345-.545a6.102 6.102 0 00-1.101-.15 6.023 6.023 0 00-1.176.072c-.218.036-.306.29-.178.517l1.786 3.135c.064.11.21.113.24.005zm.67.93l2.902 1.89c.215.14.462.052.504-.18a6.22 6.22 0 00.104-1.124 7.84 7.84 0 00-.106-1.278c-.04-.246-.287-.428-.497-.37l-2.91.81c-.103.028-.1.185.004.252zm2.693-1.359l-2.87.797c-.103.03-.215-.094-.18-.202l.95-2.999c.07-.215.327-.262.523-.096a8.601 8.601 0 011.715 1.95c.143.221.074.492-.138.55zm-3.149 1.64l.887 3.34c.066.249.324.412.53.335a4.753 4.753 0 001.777-1.173c.148-.155.092-.446-.117-.595l-2.891-2.033c-.104-.072-.218.005-.186.127zm-2.64-4.113l1.938 2.994c.07.108 0 .23-.114.199l-3.196-.888c-.23-.064-.385-.335-.31-.548.095-.277.252-.656.488-1.057.204-.345.44-.63.621-.824.149-.158.43-.097.574.124zm1.821 3.467l-3.159-.573c-.236-.042-.406.155-.348.404.07.304.183.722.359 1.159.204.506.427.93.597 1.22.13.224.406.296.557.144l2.095-2.105c.077-.078.013-.23-.101-.25zm-1.42 2.938l1.703-2.43c.061-.088.21-.035.237.09l.852 3.394c.063.246-.104.442-.335.398a7.525 7.525 0 01-1.208-.34 7.536 7.536 0 01-1.067-.51c-.22-.127-.31-.423-.183-.602z",
    fill: "url(#Veggies_svg__paint7_linear_1811_217980)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint0_linear_1811_217980",
    x1: 17.979,
    y1: 17.266,
    x2: 17.919,
    y2: 4.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint1_linear_1811_217980",
    x1: 9.717,
    y1: 15.546,
    x2: 9.607,
    y2: 0.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint2_linear_1811_217980",
    x1: 12.175,
    y1: 14.832,
    x2: 15.868,
    y2: -0.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DB159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint3_linear_1811_217980",
    x1: 13.81,
    y1: 7.26,
    x2: 10.557,
    y2: 21.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint4_linear_1811_217980",
    x1: 3.803,
    y1: 11.604,
    x2: 5.447,
    y2: 22.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint5_linear_1811_217980",
    x1: 6.037,
    y1: 11.49,
    x2: 7.766,
    y2: 21.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC831F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint6_linear_1811_217980",
    x1: 5.12,
    y1: 11.71,
    x2: 7.138,
    y2: 21.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD597"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Veggies_svg__paint7_linear_1811_217980",
    x1: 6.954,
    y1: 12.398,
    x2: 6.954,
    y2: 21.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Veggies_svg__clip0_1811_217980"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Veggies.269a5e48.svg";
export { SvgVeggies as ReactComponent };